var app = angular.module('leonardo');

var FormPassword = function() {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      readonly: '=ngReadonly',
      maxlength: '=ngMaxLength',
      minlength: '=ngMinlength',
      blur: '&ngBlur',
      focus: '&ngFocus',
      label: '@',
      placeholder: '@',
      autocomplete: '@',
      change: '&ngChange',
      backgroundColor: '@',
      onSubmit: '&',
    },
    templateUrl: 'views/templates/form/form-password.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];

      scope.$watch('value', function (value) {
        scope.ngModelCtrl.$setViewValue(value);
      });

      scope.ngModelCtrl.$render = function () {
        scope.value = scope.ngModelCtrl.$viewValue;
      };

      element.find('input').bind("keydown keypress", function (e) {
        if (e.keyCode === 13) {
          scope.$apply(function() {
            scope.onSubmit();
         });
          e.preventDefault();
        }
      });
    }
  };
};

app.directive('formPassword', [FormPassword]);
